export default __webpack_public_path__ + "static/media/logo-dark.f879f1e2.svg";